import { useContext } from 'react';
import CaptionsChildViewContext from './CaptionsChildViewContext';

export default function useCaptionsChildViewContext() {
  const context = useContext(CaptionsChildViewContext);

  if (context === undefined) {
    throw new Error(
      'useCaptionsChildViewContext must be used within CaptionsChildViewProvider',
    );
  }

  return context;
}
